import { theme } from '@features/lci-report/domain/theme';
import { PositionProps, TextProps } from '@features/powerpoint';

export const stepBox = (
  header: string,
  text: string,
  position: PositionProps
): TextProps => ({
  text: [
    {
      text: header.toUpperCase(),
      options: { bold: true, breakLine: true },
    },
    {
      text,
    },
  ],
  options: {
    fill: { color: '#434343' },
    color: theme.colors.white,
    fontSize: 14,
    valign: 'top',
    margin: 8,
    ...position,
  },
});
